import { useLDClient } from "launchdarkly-react-client-sdk";
import { useLocalStorage } from "./useLocalStorage";
import { useEffect, useState } from "react";
import { useOperator } from "./useOperator";

export default function useIdentifyLDClient() {
  const user = useOperator();
  const operator = user?.operator;
  const ldClient = useLDClient();
  const [ldKey, setLdKey] = useLocalStorage("ldKey");
  const [hasInitialized, setHasInitialized] = useState(false);

  const shouldIdentify =
    operator?.id && ldKey?.key !== operator?.id && !hasInitialized;

  useEffect(() => {
    if (shouldIdentify) {
      ldClient.identify({
        kind: "operator",
        key: operator.id,
        name: operator.name,
        slug: operator.nameSlug,
        plan: operator.plan,
      });
      setLdKey({
        ...ldKey,
        key: operator.id,
        name: operator.name,
        plan: operator.plan,
        slug: operator.nameSlug,
      });
      setHasInitialized(true);
    }
  }, [
    hasInitialized,
    ldClient,
    ldKey,
    operator?.id,
    operator?.name,
    operator?.nameSlug,
    operator?.plan,
    setLdKey,
    shouldIdentify,
  ]);
}
